<template>
  <div>
    <Return_product_list/>
  </div>
</template>

<script>
import Return_product_list from "@/components/adminArin/pos_system/warehouse/return_product/Return_product_list";
export default {
  name: "Returnproductlist",
  components: {
    Return_product_list
  }
}
</script>

<style scoped>

</style>
